module.exports = __webpack_public_path__ + "static/media/edit.23f60542.svg";